import { render } from "./UserSignatureManager.vue?vue&type=template&id=d89d6df6&scoped=true"
import script from "./UserSignatureManager.vue?vue&type=script&lang=js"
export * from "./UserSignatureManager.vue?vue&type=script&lang=js"

import "./UserSignatureManager.vue?vue&type=style&index=0&id=d89d6df6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d89d6df6"]])

export default __exports__